<template>
  <el-card class="card-main">
    <el-tabs v-model="activeName" @tab-click="tabChange">
      <el-tab-pane label="待处理" name="0"></el-tab-pane>
      <el-tab-pane label="已处理" name="1"></el-tab-pane>
      <el-tab-pane label="我发起" name="2"></el-tab-pane>
      <el-tab-pane label="抄送我的" name="3"></el-tab-pane>
    </el-tabs>
    <router-view></router-view>
  </el-card>
</template>

<script>
export default {
  name: 'MyApproval',
  data () {
    return {
      activeName: '0',
      urls: [
        '/myapproval/workspace/unfinished',
        '/myapproval/workspace/finished',
        '/myapproval/workspace/submit',
        '/myapproval/workspace/cc'
      ]
    }
  },
  computed: {
    url () {
      return this.urls[this.activeName]
    },
    currentPath () {
      return this.$route.path
    }
  },
  watch: {
  },
  created () {
    this.activeName = this.urls.findIndex(item => item === this.currentPath) + ''
  },
  methods: {
    tabChange () {
      this.$router.replace(this.url)
    }
  }
}
</script>

<style scoped lang="scss">
.webview-main {
  height: calc(100vh - 102px);

  ::v-deep {
    .el-card__body {
      height: 100%;
    }
  }
}

.iframe {
  border: 0;
  width: 100%;
  height: 100%;
  vertical-align: top;
}

::v-deep .card-main {
  padding: 0 !important;
}

::v-deep .el-card__body {
  padding: 0 20px !important;
}
</style>
